<script>
import { sortBy, groupBy } from "lodash";

export default {
    name: "ItemCategory",
    data() {
        return {
            submitted: false,
            tableData: [],
            modalTitle: "",
            totalRows: 1,
            currentPage: 1,
            perPage: 1,
            pageOptions: [1, 10, 25, 50, 100],
            filter: "",
            filterOn: [],
            sortBy: "name",
            sortDesc: false,
            fields: [
                {
                    key: "name",
                    sortable: true,
                },
                {
                    key: "categoryCode",
                    label: "Category Number",
                    sortable: true,
                },
                {
                    key: "type",
                    sortable: true,
                },
            ],
            indexSelected: -1,
            tableBusy: false,
            categories: [],
            technicalUsers: [],
        };
    },
    computed: {
        filtered(){
            let data = this.tableData;
            var total = this.currentPage * this.perPage;
            if (this.filter.trim() != "" && this.filter) {
                data = data.filter((item) => {
                    return item.filterKey
                        .toUpperCase()
                        .includes(this.filter.toUpperCase());
                });
            }
            data = data.slice(total - this.perPage, total);
            return data;
        },
        rows() {
            if (this.filter.trim() != "" && this.filter) {
                let data = this.tableData;
                data = data.filter((item) => {
                    return item.filterKey
                        .toUpperCase()
                        .includes(this.filter.toUpperCase());
                });
                return data.length;
            }
            return this.tableData.length;
        },
    },
    methods: {
        hideModal() {
            this.$bvModal.hide("ic-modal");
        },
        onRowSelected(data) {
            this.$emit("dropData", data);
            this.$bvModal.hide("item-category-modal");
        },
        async getItemCategories(){
            await this.$store
                .dispatch("itemcategory/GetItemCategory")
                .then((res) => {
                    let categoryData = groupBy(res.data, "itemCategoryGroupId");
                    let categoryGroup = [];
                    for (const [key, value] of Object.entries(categoryData)) {
                        let category = {
                            id: key,
                            name: value[0].itemCategoryGroup.name,
                            children: value,
                            technicalUsers: '',
                            filterKey: '',
                        };
                        if(this.technicalUsers.length > 0){
                            let technicalUsers = this.technicalUsers.filter((user) => user.itemCategoryGroupId == key);
                            if(technicalUsers.length > 0){
                                technicalUsers.forEach((user, index) => {
                                    let fullName = user.applicationUser.completeName;
                                    if(index == 0){
                                        category.technicalUsers = fullName;
                                    }else{
                                        category.technicalUsers += ', ' + fullName;
                                    }
                                });
                            }
                        }
                        category.filterKey = category.name + ' ' + category.technicalUsers;
                        category.children.forEach((child) => {
                            child.filterKey = `${child.name}`;
                            category.filterKey += ` ${child.name}`;
                        });
                        categoryGroup.push(category);
                    }
                    this.tableData = sortBy(categoryGroup, "name");
                })
                .catch((err) => {
                    console.log(err)
                    this.tableBusy = false;
                    this.showToast("Something went wrong!","error");
                });
        },
        async getTechnicalUsers() {
            await this.$store
                .dispatch("technicalreviewuser/GetTechnicalUserByCampus", this.$store.state.data.selectedCampus.id)
                .then((res) => {
                    if(res.data.error){
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    this.technicalUsers = res.data;
                })
                .catch((err) => {
                    this.tableBusy = false;
                    this.showToast("Something went wrong!","error");
                });
        },
        filteredCategory(children){
            let data = children;
            if (this.filter.trim() != "" && this.filter) {
                data = data.filter((item) => {
                    return item.filterKey
                        .toUpperCase()
                        .includes(this.filter.toUpperCase());
                });
            }
            return data;
        }
    },
    async created() {
        this.tableBusy = true;
        await this.getTechnicalUsers();
        await this.getItemCategories();
        this.tableBusy = false;
    },
};
</script>

<template>
    <b-modal
        id="item-category-modal"
        title="Item Category List"
        size="lg"
        title-class="font-18"
        hide-footer
        no-close-on-backdrop
    >
        <div class="row mt-1">
            <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter">
                    <label class="d-inline-flex align-items-center">
                        Search:
                        <b-form-input
                            autocomplete="off"
                            v-model="filter"
                            type="search"
                            placeholder="Search..."
                            class="form-control form-control-sm ms-2"
                        ></b-form-input>
                    </label>
                </div>
            </div>
        </div>
        <div class="table-responsive mb-0">
            <table class="table table-bordered table-striped">
                <thead>
                    <tr>
                        <th>Item Category Name</th>
                    </tr>
                </thead>
                <tbody>
                    <template v-for="group in filtered">
                        <tr :key="group.id">
                            <td colspan="100%">
                                <div><b>{{group.name}}</b></div>
                                <div class="text-warning"><small>{{group.technicalUsers ? group.technicalUsers : 'None'}}</small></div>
                            </td>
                        </tr>
                        <tr v-for="category in filteredCategory(group.children)" :key="`A${group.id}B${category.id}`">
                            <td>
                                <div class="ms-4 font-size-12 hover-underline cursor-pointer" @click="onRowSelected(category)">{{category.name}}</div>
                            </td>
                        </tr>
                    </template>
                </tbody>
            </table>
        </div>
        <div class="row">
            <div class="col">
                <div
                    class="dataTables_paginate paging_simple_numbers float-end"
                >
                    <ul class="pagination pagination-rounded mb-0">
                        <!-- pagination -->
                        <b-pagination
                            v-model="currentPage"
                            :total-rows="rows"
                            :per-page="perPage"
                        ></b-pagination>
                    </ul>
                </div>
            </div>
        </div>
    </b-modal>
</template>